import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { PackCard } from '../components/PackCard';
const packs = [{
  title: 'Nutrición',
  description: 'Sistema completo para nutricionistas: planes, recetas, seguimiento y educación alimentaria.',
  packTitle: 'NUTRICIÓN LISTA',
  themeColor: 'navy' as const,
  imageSrc: 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779676327/nutri-Photoroom_lqu1oy.png',
  href: 'https://nutripro.bibliotecaprofesional.com/',
  category: 'profesionales'
}, {
  title: 'Kinesiologia',
  description: 'Protocolos, sesiones y materiales listos para trabajar con pacientes.',
  packTitle: 'FONO PRO',
  themeColor: 'blue' as const,
  imageSrc: 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779683333/hf_20260430_234428_41cb3c68-981e-4c20-8031-afe469b66fa3-Photoroom_t5d1cd.webp',
  href: 'https://kinesiologia.bibliotecaprofesional.com/',
  category: 'profesionales'
}, {
  title: 'Estimulacion Temprana',
  description: 'Material profesional organizado por edades, listo para usar en sesiones y consultorio.',
  packTitle: 'PSICO PRO',
  themeColor: 'green' as const,
  imageSrc: 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779678784/hf_20260505_021521_8449f97b-f5da-48cc-920a-25564eca795d-Photoroom_crk2ki.webp',
  href: 'https://estimulacion.bibliotecaprofesional.com/',
  category: 'profesionales'
}, {
  title: 'Nutricion',
  description: 'Planificaciones, actividades y recursos listos para aplicar.',
  packTitle: 'PSICOPEDAGÓGICO PRO',
  themeColor: 'purple' as const,
  imageSrc: 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779683464/hf_20260505_030954_f3af6f54-07ee-4691-a63f-5e12ebacd2ee-Photoroom_yy1k1x.webp',
  href: 'https://carreranutri.bibliotecaprofesional.com/',
  category: 'estudiantes'
}, {
  title: 'Kinesiologia',
  description: 'Herramientas clínicas y actividades listas para usar en consultorio.',
  packTitle: 'TERAPIA OCUPACIONAL',
  themeColor: 'teal' as const,
  imageSrc: 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779683311/hf_20260503_134623_1bb422cd-84e7-4ec9-9a58-4fe2f3159cdc-Photoroom_s9tico.webp',
  href: 'https://kinesiologia.bibliotecaprofesional.com/',
  category: 'estudiantes'
}, {
  title: 'Psicologia',
  description: 'Herramientas clínicas y actividades listas para usar en consultorio.',
  packTitle: 'TERAPIA OCUPACIONAL',
  themeColor: 'teal' as const,
  imageSrc: 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779683525/hf_20260520_174347_12932f9a-1a74-4f23-8277-79ff39ba8c41-Photoroom_l0swcp.webp',
  href: 'https://carrerapsico.bibliotecaprofesional.com/',
  category: 'estudiantes'
}, {
  title: 'Medicina',
  description: 'Herramientas clínicas y actividades listas para usar en consultorio.',
  packTitle: 'TERAPIA OCUPACIONAL',
  themeColor: 'teal' as const,
  imageSrc: 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779683538/hf_20260520_012628_b35a9d4b-1091-4884-813f-88053f218137-Photoroom_1_nwvifg.webp',
  href: 'https://medicina.bibliotecaprofesional.com/',
  category: 'estudiantes'
}];
export function ElegirPack() {
  const [selectedCategory, setSelectedCategory] = useState<'profesionales' | 'estudiantes'>('profesionales');
  const filteredPacks = packs.filter(pack => pack.category === selectedCategory);
  return <div className="min-h-screen bg-[#F6F5F2] py-16 px-4 sm:px-6 lg:px-8 font-sans selection:bg-green-200 selection:text-green-900" data-id="element-38">
      <div className="max-w-[1400px] mx-auto" data-id="element-39">
        <div className="flex flex-col items-center text-center mb-16" data-id="element-40">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.4
        }} className="bg-[#E5F7EB] text-[#0A7D3B] text-xs font-bold px-4 py-1.5 rounded-full tracking-wider uppercase mb-6" data-id="element-41">
            Packs digitales para profesionales y estudiantes
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-[#111111] tracking-tight mb-6" data-id="element-42">
            ¿Qué tipo de material buscas?
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-lg md:text-xl text-gray-500 max-w-2xl mx-auto mb-8" data-id="element-43">
            Elegí tu pack y accedé a recursos listos para usar, imprimir y
            ahorrar horas de trabajo.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="flex flex-wrap items-center justify-center gap-3" data-id="element-44">
            <button onClick={() => setSelectedCategory('profesionales')} className={`px-6 lg:px-8 py-3 rounded-full font-semibold text-base leading-none transition-all duration-150 min-w-[170px] ${selectedCategory === 'profesionales' ? 'bg-[#0A7D3B] text-white shadow-[0_5px_0_0_#065F2C]' : 'bg-white text-[#0A7D3B] border border-[#0A7D3B]'}`} data-id="element-45">
              Profesionales
            </button>

            <button onClick={() => setSelectedCategory('estudiantes')} className={`px-6 lg:px-8 py-3 rounded-full font-semibold text-base leading-none transition-all duration-150 min-w-[170px] ${selectedCategory === 'estudiantes' ? 'bg-[#0A7D3B] text-white shadow-[0_5px_0_0_#065F2C]' : 'bg-white text-[#0A7D3B] border border-[#0A7D3B]'}`} data-id="element-46">
              Estudiantes
            </button>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 justify-items-center" data-id="element-47">
          {filteredPacks.map((pack, index) => <PackCard key={pack.title} title={pack.title} description={pack.description} packTitle={pack.packTitle} themeColor={pack.themeColor} imageSrc={pack.imageSrc} href={pack.href} delay={0.3 + index * 0.1} data-id="element-48" />)}
        </div>
      </div>
    </div>;
}